import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Loader2 } from "lucide-react";
import { useAppraisalResponse } from "@/hooks/use-appraisal";

export function AppraisalResponseActions({ claimId, requestEventId }: { claimId: number; requestEventId: number }) {
    const {
        isAppraiser,
        appraisalOutcomes,
        selectedOutcome,
        setSelectedOutcome,
        notes,
        setNotes,
        outcome,
        canSubmit,
        handleSubmit,
        isSubmittingAppraisalResponse,
    } = useAppraisalResponse(claimId, requestEventId);

    if (!isAppraiser) return null;

    return (
        <div className="mt-3 space-y-3 border-t pt-3" data-testid="appraisal-response-actions">
            <p className="text-xs font-medium text-muted-foreground">Appraisal review</p>
            <div className="grid gap-2 sm:grid-cols-2">
                {appraisalOutcomes.map((item) => (
                    <Button
                        key={item.value}
                        type="button"
                        variant={selectedOutcome === item.value ? "default" : "outline"}
                        size="sm"
                        className="h-auto justify-start whitespace-normal text-left"
                        aria-pressed={selectedOutcome === item.value}
                        onClick={() => setSelectedOutcome(item.value)}
                    >
                        {item.label}
                    </Button>
                ))}
            </div>
            {outcome && (
                <Textarea
                    value={notes}
                    onChange={(event) => setNotes(event.target.value)}
                    placeholder="Add review notes for the PA or contractor..."
                    className="min-h-20 resize-y"
                    disabled={isSubmittingAppraisalResponse}
                    aria-label="Appraisal review notes"
                />
            )}
            {outcome && (
                <Button type="button" size="sm" onClick={handleSubmit} disabled={!canSubmit || isSubmittingAppraisalResponse}>
                    {isSubmittingAppraisalResponse && <Loader2 className="mr-1 h-3.5 w-3.5 animate-spin" />}
                    Post appraisal update
                </Button>
            )}
        </div>
    );
}
